import { formatDuration } from "./formatters";

export function kpiTrend(current, prior, compareLabel, { duration = false } = {}) {
  const now = Math.max(0, Number(current) || 0);
  const before = Math.max(0, Number(prior) || 0);
  const delta = now - before;
  if (!delta) {
    return { text: compareLabel, tone: "flat" };
  }
  const sign = delta > 0 ? "+" : "-";
  const amount = duration ? formatDuration(Math.abs(delta)) : String(Math.abs(delta));
  return {
    text: `${sign}${amount} ${compareLabel}`,
    tone: delta > 0 ? "up" : "down",
  };
}
